import React, { useEffect, useRef } from 'react';
import './servicesInfoCompany.scss';

const ServicesInfoCompany = () => {
  const lineRefs = useRef([]);
  const parRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    const parObservers = parRefs.current.map((parRef) => {
      if (!parRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('services-info__text--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(parRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
      parObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="services-info">
      <section className="services-info__section">
        <div className="services-info__content">
          <h1 className="services-info__title content__title-backgroundWhite">
            Neuropsicología al servicio de tu producción
          </h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <div
            ref={(el) => (parRefs.current[0] = el)}
            className="services-info__text services-info__text--hidden"
          >
            <p className="services-info__text-paragraph content__text-title-backgroundWhite">
              En el mundo audiovisual actual,{' '}
              <strong>
                la diferencia entre una producción memorable y una ordinaria
                reside en la conexión emocional con el espectador
              </strong>
              . La neuropsicología aplicada nos permite entender cómo el cerebro
              humano procesa las historias, los personajes y las emociones, y
              utilizar ese conocimiento para{' '}
              <strong>optimizar cada decisión creativa y estratégica</strong>.
            </p>
            <p className="services-info__text-paragraph content__text-title-backgroundWhite">
              En <strong>WONDERALY INNOVATIONS</strong>, ofrecemos un ecosistema
              de servicios especializados que integran neuropsicología,
              Inteligencia Artificial y Business Intelligence para acompañar a
              productoras y equipos creativos en cada fase del proceso
              audiovisual. Desde el desarrollo del guión hasta la distribución,{' '}
              <strong>
                convertimos la ciencia del comportamiento humano en ventaja
                competitiva real y medible
              </strong>
              .
            </p>
            <p className="services-info__text-paragraph content__text-title-backgroundWhite">
              Creemos en{' '}
              <strong>
                soluciones personalizadas, basadas en evidencia y centradas en
                las personas
              </strong>
              . Cada proyecto es único, y nuestro equipo se implica de forma
              profunda para garantizar que
              <strong>
                {' '}
                la neuropsicología se adapte a tu producción y no al revés
              </strong>
              .
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesInfoCompany;
